import { useEffect, type ReactNode } from 'react'
import Lenis from 'lenis'
import { useIsMobile } from '../hooks/useIsMobile'
import { lenisRef } from '../lib/lenisInstance'
import { easeInOutCubic } from '../lib/easing'

export function SmoothScroll({ children }: { children: ReactNode }) {
  const isMobile = useIsMobile()

  useEffect(() => {
    if (isMobile) return

    const lenis = new Lenis({
      duration: 1.4,
      easing: easeInOutCubic,
      smoothWheel: true,
    })
    lenisRef.current = lenis

    let rafId: number
    function raf(time: number) {
      lenis.raf(time)
      rafId = requestAnimationFrame(raf)
    }
    rafId = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(rafId)
      lenis.destroy()
      lenisRef.current = null
    }
  }, [isMobile])

  return <>{children}</>
}
